/** Couleurs imposées par le lot DI § 5 — aucun violet (réservé à l'IA). */
export const COULEUR_MARCHE = '#007BFF';
export const COULEUR_PORTEFEUILLE = '#EB6834';
export const COULEURS_FAMILLES = {
  chr: '#007BFF',
  retail: '#E87BA4',
  services: '#1BAF7A',
  services_reglementes: '#EDA100',
  non_reconnues: '#94A3B8',
};
export const GRILLE = '#E2E8F0';
export const AXE = '#64748B';
